import { call, put, takeEvery } from 'redux-saga/effects';
import { getContactAttributeActivity } from '../../services/activityService/activityService';
import {
  getContactAttributeActivityRequest,
  getContactAttributeActivitySuccess,
  getContactAttributeActivityFailure,
} from './activity.action';
import { GET_CONTACT_ATTRIBUTE_ACTIVITY_REQUEST } from './activity.types';
import { GetContactAttributeActivityResponse } from 'types/activity/activity.types';

// Get Contact Attribute Activity Saga
function* getContactAttributeActivitySaga(
  action: ReturnType<typeof getContactAttributeActivityRequest>
) {
  try {
    const { contactId, page = 0, limit = 10 } = action.payload;
    const response: GetContactAttributeActivityResponse = yield call(
      getContactAttributeActivity,
      contactId,
      page,
      limit
    );
    yield put(getContactAttributeActivitySuccess(response));
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      'Failed to fetch contact attribute activity';
    yield put(getContactAttributeActivityFailure(errorMessage));
  }
}

// Root activity saga
export function* activitySaga() {
  yield takeEvery(
    GET_CONTACT_ATTRIBUTE_ACTIVITY_REQUEST,
    getContactAttributeActivitySaga
  );
}
